import { CALL_API } from "../api.middleware";

export const getDistFoliobyPan = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistFoliobyPan",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getAccountStatement = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetAccountStatement",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getMailbackSoaStatus = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SOAMailBackReport",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getMailbackList = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistMailbackList",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const GetDistMailbackRequest = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistMailbackRequest",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getElssStatment = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveElssReport",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getcaptialgainStatment = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CapitalGainsByEmailID",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`)
  }
};

export const getNetworthPortfolio = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_NetWorthPortfolio",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`)
  }
};

export const getMailBackRequestStatus = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetMailBackRequestStatus",
        params,
        method: "GET"
      }
    });
  } catch (error) {
    alert(`${error}`)
  }
};
